'use client'
import {
  Col,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'
import { BalanceProjectDetails } from './balance-project.details'
import { BalanceProjectHistory } from './balance-project.history'
import { useTranslate } from '@repo/shared/hooks'

export const BalanceCryptoContainer = ({
  projectId,
}: {
  projectId: string
}) => {
  const { t } = useTranslate()
  const tabs = [
    {
      value: 'sellAndBuy',
      label: t('walletPage_history_sell'),
    },
  ]
  return (
    <Col className='min-h-screen items-start mb-8xl md:mb-3'>
      <BalanceProjectDetails projectId={projectId} />

      <Tabs
        defaultValue='sellAndBuy'
        color='base'
        size='md'
        scrollable={false}
        className='w-full mt-md'
      >
        <TabsList className='w-full md:w-fit'>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className='w-full'>
            {tab.value === 'sellAndBuy' && (
              <BalanceProjectHistory projectId={projectId} />
            )}
          </TabsContent>
        ))}
      </Tabs>
    </Col>
  )
}
